import Environment from 'helpers/environment'
import Brand from 'helpers/brand'

class Apptentive {
  static createConversation (session) {
    window.ApptentiveSDK?.createConversation({
      person: {
        unique_token: session.userId,
        custom_data: {
          dealer_id: session.dealerId,
          email: session.dealerEmail,
          zip_code: session.zip,
          state: session.state,
          device_count: session.deviceCount
        }
      }
    })
  }

  static getApptentiveAccountId () {
    if (Environment.isProduction()) {
      return Brand.isASAirHome() ? '641e0e0ce2741f0adc000006' : '641e0f78e2741f0b5e000011'
    } else {
      return Brand.isASAirHome() ? '641e0c4fcd76674908000002' : '63f66aa74acadb107900000f'
    }
  }

  static sendEvent (eventName) {
    window.ApptentiveSDK?.engage(eventName)
  }
}

export default Apptentive
